<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('studentInvoice.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentInvoice.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start">
            <ts-button
              @click.prevent="onPush"
              color="primary"
              :waiting="waiting"
            >
              {{ $t('studentInvoice.submit') }}
            </ts-button>
          </div>
          <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('studentInvoice.search')"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :expandable="true"
      >
        <template v-slot="{ record }">
          <td>{{ record.branch_name_en }}</td>
          <td>{{ record.bill_date }}</td>
          <td>{{ record.card_number }}</td>
          <td>{{ record.full_name }}</td>
          <td class="text-right">
            {{ record.total_amount + ' ' + record.currency_id }}
          </td>
        </template>
        <div slot="expand" slot-scope="prop">
          <table class="ts-w-full">
            <thead>
              <tr>
                <th class="ts-w-5">{{ $t('studentInvoice.no') }}</th>
                <th>{{ $t('studentInvoice.itemName') }}</th>
                <th class="ts-w-5">{{ $t('studentInvoice.qty') }}</th>
                <th class="ts-w-5">{{ $t('studentInvoice.price') }}</th>
                <th class="ts-w-5">{{ $t('studentInvoice.amount') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(inv, index) in prop.record.invoice_detail"
                :key="index"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ inv.item_name }}</td>
                <td>{{ inv.quantity }}</td>
                <td class="ts-font-bold ts-whitespace-no-wrap">
                  {{ inv.price + ' ' + prop.record.currency_id }}
                </td>
                <td class="ts-font-bold ts-whitespace-no-wrap">
                  {{ inv.amount + ' ' + prop.record.currency_id }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  props: ['fetch'],
  name: 'studentInvoice',
  data() {
    return {
      loading: false,
      waiting: false,
      columns: [
        { name: this.$t('studentInvoice.branchName') },
        { name: this.$t('studentInvoice.invoiceDate') },
        { name: this.$t('studentInvoice.studentCardNumber') },
        { name: this.$t('studentInvoice.studentName') },
        {
          name: this.$t('studentInvoice.totalAmount'),
          style: 'width:100px; text-align:right'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('studentInvoice', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.studentInvoice.search
      },
      set(newValue) {
        this.$store.commit('studentInvoice/SET_SEARCH', newValue)
        this.$store.commit('studentInvoice/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('studentInvoice/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onPush() {
      this.waiting = true
      this.$store
        .dispatch('studentInvoice/store', [])
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
